// recon-vat-messages translations (Spanish catalog).
window.PlummeI18n.register('es', {
  'rcv.flag.duplicate': 'Posible justificante duplicado',
  'rcv.flag.salesWithoutDoc': 'Las ventas sin IVA requieren documentación',
  'rcv.flag.creditNote': 'Nota de crédito — comprueba la periodificación',
  'rcv.item.customer': 'Cliente',
  'rcv.item.otherSale': 'Otra venta',
  'rcv.item.purchase': 'Compra',
  'rcv.check.registered': 'La empresa está registrada en el IVA durante el periodo',
  'rcv.check.treatment': 'Todas las transacciones tienen el tratamiento del IVA determinado',
  'rcv.check.outgoing': 'El IVA repercutido del libro mayor coincide con los códigos de IVA',
  'rcv.check.incoming': 'El IVA soportado del libro mayor coincide con los códigos de IVA',
  'rcv.check.direct': 'Los asientos directos en las cuentas de IVA están identificados',
  'rcv.check.duplicates': 'Los posibles duplicados están identificados',
  'rcv.check.deduction': 'Las compras con derecho a deducción limitado están identificadas',
  'rcv.check.reverse': 'La inversión del sujeto pasivo está identificada',
  'rcv.check.import': 'Las importaciones de mercancías tienen declaración de aduana',
  'rcv.check.exempt': 'Las ventas sin IVA están identificadas',
  'rcv.check.credit': 'Las notas de crédito del periodo están identificadas',
  'rcv.check.settlement': 'La cuenta de liquidación se saldó en el periodo anterior',
  'rcv.check.filed': 'La declaración de IVA del periodo se ha presentado',
  'rcv.src.ledger': 'Libro mayor',
  'rcv.src.sales': 'Justificantes de venta contabilizados',
  'rcv.src.purchases': 'Justificantes de compra contabilizados',
  'rcv.src.spec': 'Desglose del IVA',
  'rcv.src.customs': 'Declaraciones de aduana',
  'rcv.src.filing': 'Declaración de IVA del periodo',
  'rcv.src.payment': 'Pago y liquidación',
  'rcv.src.ledgerDetail': '{count} asientos en las cuentas de IVA del periodo',
  'rcv.src.linesDetail': '{count} líneas en el periodo',
  'rcv.src.specDetail': '{count} códigos de IVA con importe',
  'rcv.src.customsDetail': '{registered} registradas · {missing} faltan',
  'rcv.src.filingDetail': '{period} · vence {due}',
  'rcv.src.noTerm': 'No se encontró ningún periodo',
  'rcv.src.paymentDetail': '{count} pago(s) registrado(s)',
  'rcv.main.salesBasisNote': 'La base está en las cuentas de ingresos, no en una cuenta de IVA.',
  'rcv.main.net': 'IVA neto del periodo',
});
